import ReactDOM from "react-dom";
import IComponent from "components/commons/IComponent";
import "./SensorInfo.scoped.css";
import Xml2Json from "utils/Xml2Json";
import EditableDatagridCell from "components/commons/EditableDatagridCell";
import TimeUtils from "utils/TimeUtils";
import moment from "moment";
import ReactECharts from "echarts-for-react";
import PhotoFrame from "components/commons/PhotoFrame";

const SEVEN_DAYS_MS = 1000 * 60 * 60 * 24 * 7;
const CHART_OPTION = {
  tooltip: {
    show: true,
  },
  xAxis: {
    type: "time",
    axisLabel: {
      formatter: "{MM}/{dd}",
    },
  },
  yAxis: {
    type: "value",
  },
  series: [
    {
      data: [],
      type: "line",
    },
  ],
};
class SensorInfo extends IComponent {
  constructor(props) {
    super(props);
    let { lastReadingDate } = props;
    if (!lastReadingDate) lastReadingDate = Date.now();
    else
      lastReadingDate = moment(lastReadingDate, "DD/MM/YYYY HH:mm:ss")
        .toDate()
        .getTime();
    this.state = {
      sensorReading: null,
      fromDate: TimeUtils.removeTimePart(lastReadingDate) - SEVEN_DAYS_MS,
      toDate: TimeUtils.getTimeBeforeNextDay(lastReadingDate),
    };
  }
  componentDidMount() {
    this.getSensorReading();
  }
  componentWillUnmount() {
    console.debug("Sensor Info destroyed");
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      prevProps.sensorInfo != this.props.sensorInfo ||
      (this.state.fromDate != prevState.fromDate ||
        this.state.toDate != prevState.toDate)
    )
      this.getSensorReading();
  }
  getSensorReading() {
    console.debug("getSensorReading", this.state);
    let attr = this.props.sensorInfo;
    let vm = this;
    vm.setState({
      sensorReading: null,
    });
    this.makeHttpQuery(
      this.$config.LDS_WEB_SERVICE_URL + "ListSensorData",
      "POST",
      {
        ProjectID: attr.PORJECT_ID,
        SiteID: attr.SITE_ID,
        BarrierID: attr.BARRIER_ID,
        SensorID: attr.SENSOR_ID,
        StartDate: moment(this.state.fromDate).format("YYYY-MM-DD HH:mm:ss"),
        EndDate: moment(this.state.toDate).format("YYYY-MM-DD HH:mm:ss"),
      },
      true
    )
      .then((result) => {
        result = JSON.parse(result);
        //let newContainer = document.createElement("DIV");
        vm.setState({
          sensorReading: result,
        });
      })
      .catch((ex) => vm.setState({ sensorReading: [] }));
  }
  isDateRangeInvalid = (from, to, SENSOR_TYP) => {
    return from > to || (SENSOR_TYP === "Camera" && to - from > SEVEN_DAYS_MS);
  };
  formatPhoto() {
    return this.state.sensorReading
      .map((i, j) => (
        <div key={`SENSOR_PHOTO_${j}`}>
          {i.SENSORDATETIME} <br />
          <PhotoFrame urlList={[i.SENSORPICTUREURL]} />
        </div>
      ))
      .reverse();
  }
  formatNumberReading() {
    console.debug(this.state.sensorReading);
    let chartData = this.state.sensorReading.map((i) => [
      moment(i.SENSORDATETIME, "DD/MM/YYYY H:mm:ss A").toDate(),
      parseInt(i.SENSORREADING),
      i.SensorDateTime,
    ]);
    console.debug(chartData);
    let chartOption = JSON.parse(JSON.stringify(CHART_OPTION));
    chartOption.series[0].data = chartData;
    chartOption.tooltip.formatter = (obj) =>
      `${obj.value[1]}<br/>${obj.value[2]}`;
    return <ReactECharts option={chartOption} style={{ height: "300px" }} />;
  }
  formatReading() {
    if (this.state.sensorReading.length == 0) return <br />;
    switch (this.props.sensorInfo.SENSOR_TYP) {
      case "Camera":
        return this.formatPhoto();
      default:
        return this.formatNumberReading();
    }
  }
  render() {
    if (!this.props.popupContainer) return <div />;
    let { SENSOR_ID, SENSOR_TYP } = this.props.sensorInfo || {};
    let jsxTree = (
      <div className="SensorInfoContainer">
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>Sensor ID</td>
              <td>{SENSOR_ID}</td>
            </tr>
            <tr>
              <td>Type</td>
              <td>{SENSOR_TYP}</td>
            </tr>
            <tr>
              <td>Remark</td>
              <td>REMARK</td>
            </tr>
          </tbody>
        </table>
        <div className="EqualWidthChildren">
          <div>From</div>
          <div>To</div>
        </div>
        <div className="EqualWidthChildren">
          <div>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "fromDate",
                  dataType: "date",
                },
                row: this.state,
              }}
              onChange={(field, value, values) => {
                let toDate = this.state.toDate;
                let fromDate = TimeUtils.removeTimePart(value);
                if (this.isDateRangeInvalid(fromDate, toDate, SENSOR_TYP))
                  toDate = TimeUtils.getTimeBeforeNextDay(
                    fromDate + SEVEN_DAYS_MS
                  );
                this.setState({ toDate, fromDate });
              }}
            />
          </div>
          <div>
            <EditableDatagridCell
              cellInfo={{
                colDef: {
                  field: "toDate",
                  dataType: "date",
                },
                row: this.state,
              }}
              onChange={(field, value, values) => {
                let toDate = TimeUtils.getTimeBeforeNextDay(value);
                let fromDate = this.state.fromDate;
                if (this.isDateRangeInvalid(fromDate, toDate, SENSOR_TYP))
                  fromDate = TimeUtils.removeTimePart(toDate) - SEVEN_DAYS_MS;
                this.setState({ toDate, fromDate });
              }}
            />
          </div>
        </div>
        {!this.state.sensorReading && (
          <div>
            <span className="icn_loading" />
            Getting sensor reading...
          </div>
        )}
        {this.state.sensorReading && this.state.sensorReading.length == 0 && (
          <div>No reading is available in the specified date range</div>
        )}
        <div className="ReadingArea">
          {this.state.sensorReading && this.formatReading()}
        </div>
      </div>
    );
    return ReactDOM.createPortal(jsxTree, this.props.popupContainer);
  }
}

export default SensorInfo;
